import React from 'react';

const MobileCommingSoon: React.FC = () => {
  return (
    <article className='relative bg-white dark:bg-jet-black flex lg:hidden flex-col items-center justify-center w-full h-[calc(100%-162px)]'>
      <hgroup className='bg-white-100 dark:bg-jet-black-100 flex flex-col items-center justify-center w-full max-w-[347px] h-[184px] border border-coal-50 dark:border-coal-border rounded'>
        <img src='/desktop.png' alt='desktop icon' className='object-contain w-10 h-8' />
        <h2 className='text-center text-2xl/6 font-semibold text-coal-250 dark:text-white mt-[18px]'>Desktop Only</h2>
        <p className='text-center text-[19px]/6 font-normal text-coal-250 dark:text-white'>Mobile comming soon</p>
      </hgroup>
    </article>
  );
};

export default MobileCommingSoon;
